import { render } from "./Payor.vue?vue&type=template&id=492a1798&scoped=true"
import script from "./Payor.vue?vue&type=script&lang=js"
export * from "./Payor.vue?vue&type=script&lang=js"

import "./Payor.vue?vue&type=style&index=0&id=492a1798&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492a1798"],['__file',"src/components/misc/Payor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "492a1798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('492a1798', __exports__)) {
    console.log('reload')
    api.reload('492a1798', __exports__)
  }
  
  module.hot.accept("./Payor.vue?vue&type=template&id=492a1798&scoped=true", () => {
    console.log('re-render')
    api.rerender('492a1798', render)
  })

}


export default __exports__